import CompartmentUsageContainer from './CompartmentUsageContainer';

export default CompartmentUsageContainer;
